export default __webpack_public_path__ + "static/media/exterior11.0037b7ed.webp";